export default __webpack_public_path__ + "static/media/wireless_keyboard.1bab9300.jpg";